<script setup>
import { computed } from 'vue'
import { useNuxtApp } from '#app'
import { useFormData } from '~/composables/useFormData'

const props = defineProps({
  title: String,
  subtitle: String
})

const { $luxon } = useNuxtApp()
const { parseDateFormatTokens } = useFormData()

const parsedTitle = computed(() => {
  return parseDateFormatTokens(props.title, $luxon);
})
const parsedSubtitle = computed(() => {
  return parseDateFormatTokens(props.subtitle, $luxon)
})
</script>

<template>
  <div class="timeline-heading">
    <h3 class="mb-1" v-if="parsedTitle">{{ parsedTitle }}</h3>
    <p class="mb-2" v-if="parsedSubtitle">{{ parsedSubtitle }}</p>
  </div>
</template>

<style scoped lang="scss">
/* card heading per mockups/redesign .section-head / .who (15px head, ink-3 sub) */
.timeline-heading {
  margin-bottom: 0.75rem;

  h3 {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: -0.2px;
  }

  p {
    font-size: 12.5px;
    color: rgb(var(--v-theme-textSubtle));
    line-height: 1.6;
  }
}
</style>
